// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__2xt0a","manageAccount":"styles_manageAccount__3ANOX","signOut":"styles_signOut__2bQIJ"};